import { render } from "./RewardCalculator.vue?vue&type=template&id=b991ed08"
import script from "./RewardCalculator.vue?vue&type=script&lang=js"
export * from "./RewardCalculator.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/RewardCalculator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b991ed08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b991ed08', __exports__)) {
    api.reload('b991ed08', __exports__)
  }
  
  module.hot.accept("./RewardCalculator.vue?vue&type=template&id=b991ed08", () => {
    api.rerender('b991ed08', render)
  })

}


export default __exports__